import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AvmPopUpComponent } from '../avm-popup/avm-popup.component';

@Component({
    selector: 'lus-home-value-estimation-widget',
    templateUrl: './home-value-estimation-widget.component.html',
    styleUrls: ['./home-value-estimation-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeValueEstimationWidgetComponent implements OnInit {
    @Input() details: any;
    @Input() isCSRMode = false;

    constructor(public dialog: MatDialog,) { }

    ngOnInit(): void {
    }

    openAvmInfoDialog() {
        const dialogRef = this.dialog.open(AvmPopUpComponent, {
            width: '500px',
            data: {
                isValuationHistory: false,
                isValuationEstimate: true
            }
        });
    }

}
